import { ToastMessagesState } from "./toast-messages-state.interface";

export function createToastMessagesState(): ToastMessagesState {
  return {
    toastMessages: [],
  };
}
